import { render, staticRenderFns } from "./FamilyTable.vue?vue&type=template&id=4c5762e9&scoped=true&lang=pug"
import script from "./FamilyTable.vue?vue&type=script&lang=ts"
export * from "./FamilyTable.vue?vue&type=script&lang=ts"
import style0 from "./FamilyTable.vue?vue&type=style&index=0&id=4c5762e9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c5762e9",
  null
  
)

export default component.exports